export const translationOrganizations_sv_part3 = {
  orgDetailDeleteOrganizationConfirm: "Ta bort organisation",
  orgDetailUnableToDeleteOrganization: "Det gick inte att ta bort organisation.",
  orgDetailInviteRedirectUrlLabel: "Omdirigerings-URL för inbjudan",
  orgDetailInviteRedirectUrlHelp:
    "Användare omdirigeras hit efter att ha accepterat en inbjudan eller slutfört registrering. Använd en godkänd HTTPS-instrumentpanels-URL. Lämna fältet tomt för att rensa det. Inbjudningar förblir blockerade tills en giltig URL anges igen.",
  orgDetailNameLabel: "Namn",
  orgDetailDomainsLabel: "Domäner",
  orgDetailDomainsPlaceholder: "acme.com, help.acme.com",
  orgDetailKnowledgeBaseIndexesLabel: "Kunskapsbasindex",
  orgDetailKnowledgeBaseIndexesHelp:
    "Ange en JSON-array. Varje post behöver `namespace` och `index_name`. `group` är valfritt.",
  orgDetailCompanyInfoLabel: "Företagsinformation",
  orgDetailAgentNameLabel: "Agentnamn",
  orgDetailProductButtonTextLabel: "Produktknapptext",
  orgDetailThumbsRating: "Tumbetyg",
  orgDetailLivechat: "Livechat",
  orgDetailIntegrations: "Integrationer",
  orgDetailUseBrandScope: "Använd varumärkesomfattning (intern)",
  orgDetailLivechatNotificationSound: "Livechat-notifikationsljud",
  orgDetailSaveSettings: "Spara inställningar",
  orgDetailAssignedChatbots: "Tilldelade chatbotar",
  orgDetailAssignedChatbotsDescription:
    "Dessa chatbot-ID:n tillhör redan den här organisationen. Skapande och kloning finns på fliken Chatbotar i organisationsvyn.",
  orgDetailNoChatbotsAssigned: "Inga chatbotar tilldelade",
  orgDetailAssignedExclusivelyTo: "Tilldelad exklusivt till {organization}",
  orgDetailAvailableToAttach: "Tillgänglig att koppla",
  orgDetailAvailableToAttachDescription:
    "Bara otilldelade chatbot-ID:n kan kopplas här. Chatbotar tilldelade till en annan organisation är avsiktligt dolda.",
  orgDetailNoUnassignedChatbots:
    "Inga otilldelade chatbot-ID:n är tillgängliga. Skapa ett från sidan Chatbot-ID:n eller koppla bort en befintlig tilldelning först.",
  // Brands section
  brandsUnableToLoad: "Det gick inte att ladda varumärken.",
  brandsCreated: "Varumärke skapat",
  brandsCouldNotCreate: "Det gick inte att skapa varumärke.",
  brandsNameCannotBeEmpty: "Namn får inte vara tomt.",
  brandsRenamed: "Varumärke namngivet",
  brandsCouldNotRename: "Det gick inte att byta namn på varumärke.",
  brandsDeleted: "Varumärke borttaget",
  brandsCouldNotDelete: "Det gick inte att ta bort varumärke.",
  brandsSaved: "Sparat",
  brandsCouldNotUpdateChatbot: "Det gick inte att uppdatera chatbot.",
  brandsTitle: "Varumärken",
  brandsIntro:
    "Gruppera chatbotar i den här organisationen i varumärken. Användare ser varumärken i omfångsväljaren när varumärkesomfång är aktiverat för organisationen.",
  brandsListTitle: "Varumärkeslista",
  brandsTotalCount: "{count} totalt",
  brandsNewBrandNamePlaceholder: "Nytt varumärkesnamn",
  brandsNoBrandsYet: "Inga varumärken ännu",
  brandsRenameName: "Byt namn på {name}",
  brandsDeleteName: "Ta bort {name}",
  brandsChatbotAssignmentsTitle: "Chatbot-tilldelningar",
  brandsNoChatbotsInOrganization: "Inga chatbotar i den här organisationen",
  brandsSelectBrandPlaceholder: "Välj varumärke",
  brandsUngrouped: "Utan grupp",
  brandsDeleteConfirmTitle: "Ta bort det här varumärket?",
  brandsDeleteConfirmDescription: "Chatbotar i det här varumärket blir utan grupp.",
  orgTypeTitle: "Kundtyp",
  orgTypeDescription:
    "Vad kunden säljer eller gör. Produktanalys grupperar och jämför kunder med det. Bara Diverge-administratörer; kunder ser det aldrig.",
  orgTypeMain: "Huvudtyp",
  orgTypeExtra: "Extratyper",
  orgTypeExtraHelp:
    "Allt annat kunden säljer eller gör, t.ex. skönhet på ett modekvartersvaruhus. Bara filter använder dem.",
  orgTypeNone: "Ingen typ ännu",
  orgTypeGroupShops: "Webbutiker",
  orgTypeGroupOther: "Inte en webbutik",
  orgTypeGroupExcluded: "Utanför analys",
  orgTypePickMainFirst: "Välj en huvudtyp först",
  orgTypeNoExtra: "Ingen",
  orgTypeSearch: "Hitta en typ",
  orgTypeNoMatch: "Ingen typ med det namnet",
  orgTypeInGroup: "I analysgruppen",
  orgTypeMessages: "{count} besökarmeddelanden de senaste 30 dagarna",
  orgTypeLastChange: "Ändrad {date} av {who}",
  orgTypeFromList: "den granskade listan",
  orgTypeNotListed:
    "Den här organisationen har ingen plattformspost ännu, så den kan inte ha en typ.",
  orgTypeLoadError: "Kunde inte ladda kundtyperna.",
  orgTypeSaveError: "Kunde inte spara kundtyperna. Försök igen om en stund.",
  orgTypeRetry: "Försök igen",
  // Language routing (Organizations/languageRouting)
  orgDetailLanguageRoutingTitle: "Routning efter språk",
  orgDetailLanguageRoutingDescription:
    "Ladda en annan chatbot för varje sidspråk. Skriptet läser sidans lang-attribut och laddar chatboten som är kopplad till språket. Sidor på alla andra språk laddar huvudchatboten.",
  orgDetailLanguageRoutingLoadError: "Kunde inte ladda språkrutterna.",
  orgDetailLanguageRoutingRetry: "Försök igen",
  orgDetailLanguageRoutingCurrentTitle: "Nuvarande rutter",
  orgDetailLanguageRoutingNoRoutes: "Ingen chatbot i den här organisationen har språkrutter ännu.",
  orgDetailLanguageRoutingColumnMain: "Huvudchatbot",
  orgDetailLanguageRoutingColumnLanguage: "Språk",
  orgDetailLanguageRoutingColumnTarget: "Laddar chatbot",
  orgDetailLanguageRoutingNeedsTwoChatbots:
    "Routning efter språk kräver minst två chatbotar i den här organisationen. Koppla en chatbot till för att ställa in det.",
  orgDetailLanguageRoutingMainLabel: "Huvudchatbot",
  orgDetailLanguageRoutingMainPlaceholder: "Välj huvudchatboten",
  orgDetailLanguageRoutingMainHelp: "Chatboten vars skript finns på kundens webbplats.",
  orgDetailLanguageRoutingRoutesLegend: "Språk för {chatbotId}",
  orgDetailLanguageRoutingNoRows:
    "Inga språk har en rutt ännu, så alla sidor laddar den här chatboten.",
  orgDetailLanguageRoutingLanguageLabel: "Språkkod",
  orgDetailLanguageRoutingLanguagePlaceholder: "sv",
  orgDetailLanguageRoutingTargetLabel: "Chatbot som laddas",
  orgDetailLanguageRoutingTargetPlaceholder: "Välj en chatbot",
  orgDetailLanguageRoutingRemoveRoute: "Ta bort rutten för {language}",
  orgDetailLanguageRoutingRemoveEmptyRoute: "Ta bort rutt {number}",
  orgDetailLanguageRoutingAddLanguage: "Lägg till språk",
  orgDetailLanguageRoutingSave: "Spara rutter",
  orgDetailLanguageRoutingSaving: "Sparar rutter",
  orgDetailLanguageRoutingInvalidLanguage:
    "Använd en språkkod med två eller tre bokstäver, t.ex. sv eller de.",
  orgDetailLanguageRoutingDuplicateLanguage: "Det här språket har redan en rutt.",
  orgDetailLanguageRoutingTargetRequired: "Välj chatboten som ska laddas för det här språket.",
  orgDetailLanguageRoutingFixErrors: "Rätta de markerade rutterna och spara igen.",
  orgDetailLanguageRoutingSaved: "Språkrutter sparade för {chatbotId}.",
  orgDetailLanguageRoutingSaveError: "Kunde inte spara språkrutterna.",
  orgDetailLanguageRoutingTargetUnavailable:
    "En chatbot som ska laddas tillhör inte längre den här organisationen. Ladda om sidan och välj igen.",
  orgDetailLanguageRoutingTooManyRoutes: "En chatbot kan ha högst 100 språk.",
  orgDetailLanguageRoutingMainUnavailable:
    "Huvudchatbotten tillhör inte längre den här organisationen. Ladda om sidan.",
  orgDetailLanguageRoutingSnippetTitle: "Skript för kundens webbplats",
  orgDetailLanguageRoutingSnippetHelp:
    "Routningen körs bara när huvudchatbotens skript har {parameter}. Byt ut huvudchatbotens nuvarande skript mot det här på alla sidor.",
};
